import GlassCard from '../../GlassCard';
import SectionHeader from '../../ui/SectionHeader';
import AboutContent from './AboutContent';
import AboutInfoCards from './AboutInfoCards';
import { aboutData } from '../../../assets/data/aboutData'

export default function About() {
  return (
    <section id="about" className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl w-full">
        <GlassCard className="border-emerald-400/30">
          <SectionHeader title="About Me" />
          
          <div className="grid gap-8 items-center">
            <AboutContent data={aboutData} />
            <AboutInfoCards cards={aboutData.infoCards} />
          </div>
        </GlassCard>
      </div>
    </section>
  );
}
